exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.ivu-table-fixed[data-v-6bd39f9c]::before,\n.ivu-table-fixed-right[data-v-6bd39f9c]::before {\n    height: 0;\n}\n", "", {"version":3,"sources":["E:/ViewUI/src/components/table/table.vue"],"names":[],"mappings":";AACA;;IAEI,UAAU;CACb","file":"table.vue","sourcesContent":["\n.ivu-table-fixed[data-v-6bd39f9c]::before,\n.ivu-table-fixed-right[data-v-6bd39f9c]::before {\n    height: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-6bd39f9c","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/table/table.vue
// module id = 568
// module chunks = 0